<template>
  <!-- 我的 -->
  <div class="my">
    <!-- 头像和个人信息 -->
    <div class="headPart">
        <!-- 头像 -->
        <div class="photo">
            <img :src="portraitYrl">
        </div>
        <div class="headright">
            <div class="info">
                <span class="userName">{{userInfoDataAccount.name&&userInfoDataAccount.name.length>15 ? userInfoDataAccount.name.substr(0,15)+'...': userInfoDataAccount.name}}</span>
                <span class="realname"  v-show="realname===1">√实名</span>
                <span class="check" v-show="userInfoDataAccount.status===4">√审核</span>
            </div>
            <div class="preview">
                <router-link id="myDetail" :to="{path:'/myDetail', query:{id:this.accountId}}">
                    <span>预览主页</span>
                </router-link>
            </div>
        </div>
    </div>
    <!-- 个人设置 -->
    <div class="setUp">
        <!-- 接单设置 -->
        <div class="setGroup">
            <span>接单设置</span>
            <mt-switch v-model="swit" @change="ordeset"></mt-switch>
        </div>
      <!-- 我的工作 -->
      <div class="setGroup" @click="$router.push('/myJobs')">
          <span>我的工作</span>
          <icon name="chevron-right" class='next money'></icon>
      </div>
      <!-- 资质认证 -->
        <div class="setGroup" @click="$router.push('/certification')">
            <span>资质认证</span>
            <icon name="chevron-right" class='next money'></icon>
        </div>
      <!-- 我的钱包 -->
      <div class="setGroup" @click="$router.push('/message')">
          <span>我的钱包</span>
          <icon name="chevron-right" class='next money'></icon>
      </div>
      <!-- 修改密码 -->
      <div class="setGroup" @click="$router.push('/passport/resetPwd')">
          <span>修改密码</span>
          <icon name="chevron-right" class='next'></icon>
      </div>
      <!-- 修改昵称 -->
      <div class="setGroup" @click="$router.push('/passport/resetNickname')">
          <span>修改昵称</span>
          <icon name="chevron-right" class='next'></icon>
      </div>
      <!-- 账号绑定 -->
      <div v-show="false" class="setGroup">
            <icon name='address-card-o' class='setIcon'></icon>
            <span>账号绑定</span>
            <icon name="chevron-right" class='next'></icon>
      </div>
      <!-- 通用设置 -->
      <div v-show="false" class="setGroup">
            <icon name='cog' class='setIcon'></icon>
            <span>通用设置</span>
            <icon name="chevron-right" class='next'></icon>
      </div>
    </div>
    <!-- 退出 -->
    <div class="quite" @click="logout">退出登录</div>
  </div>
</template>

<script>
import { Toast, MessageBox, Indicator } from 'mint-ui'
import vueCropper from 'vue-cropper'
import qs from 'qs'
import vSelect from 'vue-select'
import bus from '../../utiles/bus'

export default {
  name: 'my',
  data () {
    return {
      swit: false,
      accountId: '',
      userInfoData: '',
      userInfoDataAccount: '',
      // 图片服务器地址
      httpUrl: '',
      // 头像上传的本地路径
      portraitUrl: '',
      // 显示隐藏剪裁div
      portraitShow: false,
      // 剪裁后图路径（base64）建议将这个路径和后台取到的反显路径写在一个变量中
      portraitYrl: 'data:image/png;base64,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',
      realname:'',//判断是否实名
    }
  },
  created(){
    this.$emit('footer', true);
  },
  mounted () {
    this.loadTest()
    this.STATE.state.bottomindex='btnFive'
  },
  methods: {
    loadTest: function () {
      let _this = this
      function httpUrl () {
        return _this.axios.get('url/user/imgHttpUrl.json')
      }
      function userInfomationById () {
        return _this.axios.get('url/userName/getUserInformation?accountId='+sessionStorage.getItem('loginId'))
      }
      function loadSelect () {
        return _this.axios.get('url/account/userInfo/vueGetInfomationData')
      }
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      })
      _this.axios.all([httpUrl(),userInfomationById(),loadSelect()])
      .then(_this.axios.spread(function (imgurl, userInfo, load) {
        // console.log(userInfo.data,'123')
        Indicator.close()
        // 判断是否显示实名按钮
        if(userInfo.data.accountCertificate!==null){
          _this.realname=userInfo.data.accountCertificate.status
        }
        // 保存当前用户ID
        _this.accountId = userInfo.data.account.id
        // -----图片服务器地址
        _this.httpUrl = imgurl.data
        // -----基础数据
        if (userInfo.data.photo !== null) {
          _this.portraitYrl = imgurl.data + userInfo.data.photo
        }
        if (userInfo.data.account.orderstatus === 1) {
          _this.swit = true
          _this.STATE.state.orderstatus = 1
        } else {
          _this.swit = false
          _this.STATE.state.orderstatus = 0
        }
        // 赋值反显
        _this.userInfoData = userInfo.data
        _this.userInfoDataAccount = userInfo.data.account
      })).catch(function (response) {
        Indicator.close()
      })
    },
    ordeset: function () {
      let _this = this
      if (this.swit) {
        var Type = 'initiate'
      }
      this.axios.get('url/account/accountstatus?orderstatus=' + Type + '&accountId= ' + _this.accountId + '')
      .then(function (res) {
        if (res.data.success) {
          if (_this.swit) {
            Toast({
               // 提示
              message: '开始接单了',
               // 提示位置
              position: 'middle',
               // 提示存在时间
              duration: 1000
            })
          } else {
            Toast({
              // 提示
              message: '停止接单了',
               // 提示位置
              position: 'middle',
               // 提示存在时间
              duration: 1000
            })
          }
        }
      })
    },
    logout () {
      let _this = this
      MessageBox.confirm('', {
        title: '提示',
        message: '是否退出当前账户',
        showCancelButton: true,
        confirmButtonText: '退出',
        cancelButtonText: '取消'
      }).then(action => {
         // 绑定确定事件
        if (action === 'confirm') {
          this.axios({
            method: 'post',
            url: 'url/api/session',
            data: qs.stringify({
              _method: 'DELETE'
            })
          }).then(function (res) {
            if (res.data.success) {
              _this.STATE.state.loginState = false
              sessionStorage.setItem('loginState',false)
              _this.STATE.state.loginId = 1
              _this.STATE.state.loginPhone = 0
              _this.STATE.state.orderstatus = ''
              _this.$router.push({path: '/'})
              bus.$emit('routerBus', 'btnOne')
            }
          })
        }
      })
    },
  },
  
  components: {
    vueCropper,
    vSelect
  }
}
</script>

<style scoped>
.my{
  background-color:#f0eff5;
  padding-bottom:1px;
}
.headPart{
  background-color: #108ee9;
  padding: 50px 2%;
  position: relative;
}
.photo{
  width: 74px;
  height: 74px;
  background-color: #fff;
  border-radius:50%;
  -webkit-border-radius:50%;
  -moz-border-radius:50%;
  -ms-border-radius:50%;
  -o-border-radius:50%;
  text-align: center;
  display: inline-block;
}
.photo img{
  margin-top: 2px;
  width: 70px;
  height: 70px;
  border-radius:50%;
  -webkit-border-radius:50%;
  -moz-border-radius:50%;
  -ms-border-radius:50%;
  -o-border-radius:50%;
}
.headright{
    display: inline-block;
    /* margin-left: 10px; */
}
.headright .info{
    margin-bottom: 25px;
}
.headright .info .userName{
    color:#fff;
}
.headright .info .realname{
    background: #e19b34;
    padding: 5px;
    border-radius: 11px;
    color: #fff;
    font-size: 10px;
}
.headright .info .check{
    background: #02bd6e;
    padding: 5px;
    border-radius: 11px;
    color: #fff;
    font-size: 10px;
}
.preview{
  padding: 2px 5px;
  border-radius:15px;
  -webkit-border-radius:15px;
  -moz-border-radius:15px;
  -ms-border-radius:15px;
  -o-border-radius:15px;
  background-color:rgba(0, 0, 0, .3) ;
  text-align: center;
  width:65px;
}
.preview span{
  font-size: 12px;
  color: #fff;
}
.preview .fa-icon{
  color: #fff;
}
.setUp{
  border-top: 1px solid #ccc;
  background-color: #fff;
}
.setUp .setGroup{
  padding:0 5%;
  line-height: 40px;
  border-bottom: 1px solid #ccc;
}
.setUp .setGroup span{
  font-size: 14px;
  vertical-align: middle;
  margin-left: 5px;
}
.setUp a{
  text-decoration: none;
  color: black;
}
.mint-switch{
  display: inline-block;
  transform: scale(0.7);
  float: right;
  margin-top: 3px;
}
.setIcon{
  color:#118fec;
  vertical-align: middle;
}
.setGroup .next{
  float: right;
  margin-top: 14px;
}
.setGroup .money{
  position: absolute;
  right: 5%;
}
.quite{
  margin: 11px 0 90px;
  text-align: center;
  line-height: 40px;
  font-size: 14px;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  background-color:#fff;
}
.showData{
  width: 100%;
  height: 100%;
  overflow-y:  auto;
}
.data_wrap{
  padding: 20px;
}
.data_wrap p{
  font-size: 12px;
  color: #727272;
}
.data_wrap .dataGroup{
  margin-bottom: 20px;
}
.data_wrap input{
  display: block;
  width: 100%;
  text-align: center;
  font-size:14px;
  border: none;
  outline: none;
  border-bottom: 1px solid #d6d6d6;
  line-height: 30px;
}
.data_wrap .picker{
  position: relative;
  width: 100%;
  height: 30px;
  line-height: 30px;
  border-bottom: 1px solid #d6d6d6;
  text-align: center;
}
.data_wrap .triangle{
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid #808b98;
  position: absolute;
  right: 10px;
  top: 13px;
}
.data_wrap .picker .vals{
  font-size: 14px;
}
.data_save{
  width: 100%;
  line-height: 50px;
  text-align: center;
  color: #fff;
  background-color: #108ee9;
  margin-top: 20px;
}
  input::-webkit-input-placeholder,textarea::-webkit-input-placeholder{
    color: #b7c3ca;
  }
  input:-moz-placeholder,textarea::-moz-placeholder{
  　color:#b7c3ca;
  }
  input::-moz-placeholder,textarea::-moz-placeholder{
  　color:#b7c3ca;
  }
  input:-ms-input-placeholder,textarea:-ms-input-placeholder{
  　color:#b7c3ca;
  }
.cityPopup,.genderPopup,.typePopup{
  width: 100%;
}
.picker-toolbar{
  padding: 6px;
  overflow:hidden;
}
.cancel{
  float:left;
  font-size:12px;
  padding:5px 10px;
  border:1px solid #ccc;
  border-radius:3px;
  -webkit-border-radius:3px;
  -moz-border-radius:3px;
}
.confirm{
  float:right;
  font-size:12px;
  padding:5px 10px;
  color:#fff;
  border:1px solid #007aff;
  background-color:#007aff;
  border-radius:3px;
  -webkit-border-radius:3px;
  -moz-border-radius:3px;
}
.labels{
  padding: 20px 20px 0;
}
.labels span{
  display: inline-block;
  color: #989898;
  background-color: #f3f3f3;
  padding: 2px 10px;
  margin: 0 5px 5px;
  font-size: 12px;
  border-radius:3px;
  -webkit-border-radius:3px;
  -moz-border-radius:3px;
}
.label_val{
  padding:10px;
  overflow:hidden;
}
.label_val li{
  float:left;
  border:1px solid #007AFF;
  color:#007AFF;
  border-radius:3px;
  -webkit-border-radius:3px;
  -moz-border-radius:3px;
  padding:2px 10px;
  margin:5px;
}
.label_val li .fa-icon{
  width:12px;
  height:12px;
  margin-left:5px;
  color:#fff;
}
.select{
  background-color:#108ee9!important;
  color:#fff!important;
}
.introduce_wrap{
  padding: 20px;
}
.introduce_wrap p{
  font-size: 12px;
  display: inline-block;
}
.howWrite{
  font-size: 12px;
  padding: 2px 10px;
  background-color: #108ee9;
  color: #fff;
  border-radius:3px;
  -webkit-border-radius:3px;
  -moz-border-radius:3px;
  border: none;
  outline: none;
  float: right;
  font-weight: lighter;
}
.howWrite .fa-icon{
  transform: scale(0.7);
  vertical-align: top;
  color: #fff;
}
#introduce_val{
  width: 100%;
  border:1px solid #d6d6d6;
  resize: none;
  border-radius:5px;
  -webkit-border-radius:5px;
  -moz-border-radius:5px;
  margin-top: 14px;
  outline: none;
  font-size: 14px;
  padding: 9px 10px;
  box-sizing: border-box;
}
.write_val{
  padding: 20px;
  font-size: 14px;
}
.caseList{
  background-color: #f5f5f5;
}
.caseListVal{
  margin-top: 1px solid #ccc;
  margin-bottom: 1px solid #ccc;
  background-color: #fff;
  padding: 20px;
  margin-bottom: 6px;
}
.caseTitle{
  font-size: 14px;
  color: #727272;
}
.caseTime{
  color: #727272;
  font-size: 12px;
  margin: 10px 0;
}
.showImg{
  margin-bottom: 10px;
}
.showImg div{
  display: inline-block;
  width: 65px;
  height: 65px;
  border: 1px solid #ccc;
  vertical-align:middle;
  text-align: center;
}
.showImg div img{
  max-width: 100%;
  max-height: 100%;
  margin-top: 50%;
  transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
}
.caseListVal pre{
  font-size: 12px;
  margin: 5px 0;
}
.btns{
  text-align: right;
}
.btns button{
  background-color: #108ee9;
  color: #fff;
  border: none;
  outline: none;
  font-size: 12px;
  border-radius:3px;
  -webkit-border-radius:3px;
  -moz-border-radius:3px;
  font-weight: lighter;
}
.add{
  vertical-align: middle;
  margin-right: 5px;
}
.edit{
  padding: 20px;
}
.edit p{
  font-size: 12px;
  color: #777777;
}
.edit input{
  display: block;
  width: 100%;
  text-align: center;
  font-size: 14px;
  border: none;
  outline: none;
  border-bottom: 1px solid #d6d6d6;
  line-height: 30px;
}
.edit .editImg{
  margin: 10px 0;
}
.editImg .imgs,.editImg .addImg{
  display: inline-block;
  vertical-align: middle;
  text-align: center;
}
.editImg .imgs{
  width: 65px;
  height: 65px;
  border: 1px solid #ccc;
  position: relative;
}
.editImg .imgs img{
  max-width: 100%;
  max-height: 100%;
}
.editImg .imgs .fa-icon{
  position: absolute;
  top: -5px;
  right: -5px;
}
.editImg .addImg{
  width: 65px;
  height: 65px;
  border: 1px dashed #ccc;
}
.editImg .addImg .fa-icon{
  margin-top: 15px;
}
.industry,.caseDescribe{
  margin-top: 10px;
}
.industry div{
  font-size: 14px;
  position: relative;
  text-align: center;
  border-bottom: 1px solid #d6d6d6;
  line-height: 30px;
  height: 30px;
}
.industry .triangle{
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid #808b98;
  border-bottom: 0;
  position: absolute;
  right: 10px;
  top: 13px;
}
.caseDescribe textarea{
  margin: 5px 0;
  padding: 5px;
  font-size: 12px;
  width: 100%;
  resize: none;
  border: 1px solid #ccc;
  box-sizing: border-box;
  border-radius:3px;
  -webkit-border-radius:3px;
  -moz-border-radius:3px;
  outline: none;
}
.caseBtns{
  width: 100;
  height: 50px;
  overflow: hidden;
}
.caseBtns button{
  float: left;
  width: 50%;
  line-height: 50px;
  border: none;
  outline: none;
}
.caseBtns .deleteBtn{
  background-color: #dcecfe;
  color: #0074f8;
}
.caseBtns .saveBtn{
  background-color:#108ee9;
  color: #fff;
}
#upDataPart{
  display: none;
}
.cut{
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 5;
  background-color: #fff;
}
.cut .cutBtn{
  padding: 5px 20px;
}
#splSave{
  position: initial;
}
.dataGroup .vals{
  display: inline-block;
  margin:0 5px;
}
.preview a{
  text-decoration: none;
}
</style>




// WEBPACK FOOTER //
// index.vue?2ccbbe62